import { render, staticRenderFns } from "./Template_8.vue?vue&type=template&id=07ff9495&scoped=true"
import script from "./Template_8.vue?vue&type=script&lang=js"
export * from "./Template_8.vue?vue&type=script&lang=js"
import style0 from "./Template_8.vue?vue&type=style&index=0&id=07ff9495&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ff9495",
  null
  
)

export default component.exports